import { ISessionRepository } from '../../interfaces/core/ISessionRepository';
import { ITestSession } from '../../interfaces/core/ITestSession';

export class InMemorySessionRepository implements ISessionRepository {
  private sessions = new Map<string, ITestSession>();

  save(session: ITestSession): void {
    this.sessions.set(session.id, session);
  }

  findByLabel(label: string): ITestSession | null {
    for (const session of this.sessions.values()) {
      if (session.label === label) {
        return session;
      }
    }
    return null;
  }

  findById(id: string): ITestSession | null {
    return this.sessions.get(id) || null;
  }

  findAll(): ITestSession[] {
    return Array.from(this.sessions.values());
  }

  exists(id: string): boolean {
    return this.sessions.has(id);
  }

  delete(id: string): boolean {
    return this.sessions.delete(id);
  }

  clear(): void {
    this.sessions.clear();
  }
}
